/* gesamter Inhalt wurde in AssetCollector/NCE/karte verlagert!!!! */

$(document).ready(function() {
    // NCE Karte
    if ($.cookie('cookieConsented-analysis') === "1") {
        if ($('iframe.nce-karte').length > 0) {
            $('iframe.nce-karte').each(function(index) {
                if ($(this).data('consent-analysis') == '0') {
                    $(this).attr('src', $(this).attr('src') + "&consent-analysis=1");
                    $(this).attr('data-consent-analysis', 1);
                }
            });
        }
    }

    $(".nce-karte").each(function() {

        let $karteObj = $(this),
            thisMapOptions = Object.assign({}, _ttgMaps.mapOptions), // copy without reference
            $legendary = $karteObj.closest('.mapWrap').find('.nce-karte_legendary');

        _ttgMaps.f.loading($karteObj);

        $karteObj.index = ttgMaps.length;

        thisMapOptions.container = 'nce-karte-' + $karteObj.data('id');
        thisMapOptions.center = {
            lat: 48.31672685246021,
            lng: 14.302454766916954
        };
        thisMapOptions.zoom = 8;
        thisMapOptions.experience = $karteObj.data('mapsconfig');

        if ($karteObj.data('center').length >= 1) {

            // Custom Center Koordinaten
            thisMapOptions.center = {
                lat: $karteObj.data('center').split(',')[0],
                lng: $karteObj.data('center').split(',')[1],
                custom: true
            };

            // Custom Zoom
            if ($karteObj.data('zoomdesktop').length >= 1 || $karteObj.data('zoommobile') >= 1) {
                if ($(window).width() < 992) {
                    thisMapOptions.zoom = ($karteObj.data('zoommobile') > 0) ? $karteObj.data('zoommobile') : _ttgMaps.mapOptions.zoom;
                } else {
                    thisMapOptions.zoom = ($karteObj.data('zoomdesktop') > 0) ? $karteObj.data('zoomdesktop') : _ttgMaps.mapOptions.zoom;
                }
            }

        }

        _ttgMaps.metaParams.experience = $karteObj.data('mapsconfig');
        _ttgMaps.metaParams.mkt = $karteObj.data('lang');

        ttgMaps[$karteObj.index] = Done.Maps.newMap(thisMapOptions);

        window.echartNCE = []; // für Höhenprofil

        if (Done.Maps.isSupported()) {

            if (_ttgMaps.f.getPins($karteObj.data('pins')) || (typeof mapObjects !== 'undefined' && mapObjects[$karteObj.data('mapobjects')])) {

                ttgMaps[$karteObj.index].tourLines = [];
                ttgMaps[$karteObj.index].on('load', function() {

                    if (typeof mapObjects !== 'undefined' && mapObjects[$karteObj.data('mapobjects')]) {

                        _ttgMaps.f.nceMap.loadNCEkarte_IRRE(thisMapOptions, $karteObj, mapObjects[$karteObj.data('mapobjects')]).then(
                            function(objects) {
                                _ttgMaps.f.nceMap.legendary($karteObj, objects);
                            }
                        );

                        // MOUSEENTER / MOUSELEAVE in MAP
                        $karteObj
                            .on('mouseenter', '.ttgMaps_customPin', function() {

                                _ttgMaps.f.nceMap.highlight({
                                    mode: 'add',
                                    $pinInMap: $(this),
                                    $itemInLegend: $legendary.find('.' + $(this).data('markerID'))
                                }, $karteObj);

                            })
                            .on('mouseleave', '.ttgMaps_customPin', function() {

                                _ttgMaps.f.nceMap.highlight({
                                    mode: 'remove',
                                    $pinInMap: $(this),
                                    $itemInLegend: $legendary.find('.' + $(this).data('markerID'))
                                }, $karteObj);

                            })
                            .on('click', '.ttgMaps_customPin', function() {

                                let $pinInMap = $(this),
                                    $itemInLegend = $legendary.find('.' + $pinInMap.data('markerID'));

                                if ($itemInLegend.hasClass('active')) {

                                    $pinInMap.removeClass('active');
                                    $itemInLegend.removeClass('active');

                                    // Tourverlauf entfernen
                                    if ($pinInMap.data('itemdata').tourdata && $pinInMap.data('itemdata').tourdata.type === 'Tour') {
                                        ttgMaps[$karteObj.index].map.removeLayer('tour_' + $pinInMap.data('itemdata').tourdata.id);
                                        ttgMaps[$karteObj.index].map.removeSource('tour_' + $pinInMap.data('itemdata').tourdata.id);

                                        // Tour aus Array entfernen
                                        if (ttgMaps[$karteObj.index].tourLines.indexOf($pinInMap.data('itemdata')) > -1) {
                                            ttgMaps[$karteObj.index].tourLines.splice(ttgMaps[$karteObj.index].tourLines.indexOf($pinInMap.data('itemdata')), 1);
                                        }
                                    }

                                } else {

                                    $pinInMap.addClass('active')
                                        .find('.pulse').css('background', $pinInMap.find('svg path').attr('fill'));
                                    $itemInLegend.addClass('active')
                                        .find('.pulse').css('background', $pinInMap.find('svg path').attr('fill'));

                                    // Tourverlauf anzeigen
                                    if ($pinInMap.data('itemdata').tourdata && $pinInMap.data('itemdata').tourdata.type === 'Tour') {
                                        _ttgMaps.f.nceMap.customShowTour($pinInMap.data('itemdata'), $karteObj);
                                    }
                                    $pinInMap.css('z-index', _ttgMaps.f.nceMap.zIndexMagic($karteObj));

                                }

                            });



                    } else if (_ttgMaps.f.getPins($karteObj.data('pins'))) {

                        _ttgMaps.f.nceMap.loadNCEkarte(thisMapOptions, $karteObj, _ttgMaps.f.getPins($karteObj.data('pins')));

                    }

                    _ttgMaps.f.loading($karteObj, 'remove');

                });

                ttgMaps[$karteObj.index].on('item-selected', (ev) => {
                    console.log('item-selected', ev);
                    _ttgMaps.f.selectMapItem(ev.item.item, false, ttgMaps[$karteObj.index]);
                });

                /*
                ttgMaps[$karteObj.index].on('experience-changed', (ev) => {
                    console.log('experience-changed');
                });
                */

                // Lade Tourverläufe auch nach Style Wechsel
                // Timeout notwendig, da Experience Map Style etwas Zeit braucht um geladen zu werden
                setTimeout(function() {
                    ttgMaps[$karteObj.index].map.on('style.load', (ev) => {
                        $.each(ttgMaps[$karteObj.index].tourLines, function(index, tour) {
                            _ttgMaps.f.nceMap.customShowTour(tour, $karteObj);
                        });
                    });
                }, 500);

                // ttgMaps[$karteObj.index].map.on('zoomend', (ev) => {
                //     console.log('zoomend', ttgMaps[$karteObj.index].map.getZoom());
                // });

            }

            // FullScreen Container
            $karteObj.append($('<div class="ttgFullScreenSelectedNCEMapItem"></div>'));
            $karteObj.find('.ttgFullScreenSelectedNCEMapItem').append($('<div id="chartFullScreen_' + $karteObj.data('id') + '" class="nce-chart"></div>'));
        }
    });

});

_ttgMaps.f.nceMap = {

    zIndexMagic: function($karteObj) {

        let zIndex = 0;

        $karteObj.find('.ttgMaps_customPin').each(function() {

            let thisZIndex = ($(this).css('z-index') === 'auto') ? 0 : $(this).css('z-index');
            if (thisZIndex >= zIndex) {
                zIndex = parseInt(thisZIndex) + 1;
            }

        });

        return zIndex;

    },

    loadNCEkarte: async function(thisMapOptions, $karteObj, tdQuery) {
        // Wenn tdQuery (alter NCE Modus) dann wird die Karte über showContent() geladen

        window['mapLayer' + $karteObj.data('id')] = await ttgMaps[$karteObj.index].showContent({
            experience: $karteObj.data('mapsconfig'),
            mkt: _ttgMaps.lang,
            type: 'All',
            q: tdQuery,
            limit: 100
        });

        if ($karteObj.data('showtourlines')) {
            _ttgMaps.f.nceMap.showTourLines(window['mapLayer' + $karteObj.data('id')].result.items, $karteObj);
        }

        if (!thisMapOptions.center.custom) {
            // Falls keine Center Koordinaten gesetzt wurden, setze den Kartenausschnitt/Zoom basierend auf den Objekten
            ttgMaps[$karteObj.index].fitLayer(window['mapLayer' + $karteObj.data('id')]);
        }

    },

    loadNCEkarte_IRRE: async function(thisMapOptions, $karteObj, mapObj) {

        let pins = [],
            allCoords = [];

        if ($karteObj.data('notilt') !== 1) {
            ttgMaps[$karteObj.index].map.setPitch(_ttgMaps.mapOptions.pitch);
        }
        // ttgMaps[$karteObj.index].setMapStyle('Topo');

        $.each(mapObj, function(index, item) {

            if (item.coords) {
                // Falls es ein TD Objekt ist, hole die Daten und füge sie dem Objekt unter > item.tourdata < hinzu bzw. passe bereits erzeugtes HTML direkt an.
                if (item.tourdatatyp > 0) {

                    item.type = _ttgMaps.f.nceMap.getTDtypeString(item.tourdatatyp).charAt(0).toUpperCase() + _ttgMaps.f.nceMap.getTDtypeString(item.tourdatatyp).slice(1);
                    item.type = (item.type === 'Poi') ? 'POI' : item.type;

                    item.id = item.tourdataid;

                    _ttgMaps.f.getMapItem(item).then(
                        response => {
                            item.tourdata = response.items[0];

                            // Färbe Marker je nach Auslastung ein (sofern gewünscht)
                            if (item.pin.auslastung > 0) {
                                $.each(item.tourdata.attributes, function(index, attribute) {
                                    if (attribute.key === 'PeopleCounterState') {
                                        switch (attribute.value) {
                                            case 'low':
                                                item.pin.color = '#8bc34a';
                                                break;
                                            case 'medium':
                                                item.pin.color = '#ffa500';
                                                break;
                                            case 'high':
                                                item.pin.color = '#ff0000';
                                                break;
                                        }
                                        $('.markerID_' + $karteObj.data('mapobjects') + '-' + item.id + ' svg path').attr('fill', item.pin.color);
                                    }
                                });
                            }

                            // Falls es eine Legende gibt und kein custom Link gesetzt wurde, setze den Link lt. META
                            if (item.link.length == 0 && item.tourdata && item.tourdata.web && item.tourdata.web.length > 0) {
                                // falls Location, korrigiere auf Location-Link
                                if (item.tourdatatyp == 9) {
                                    link = item.tourdata.web;
                                    item.tourdata.web = link.replace("oesterreich-unterkunft", "oesterreich-location");
                                }

                                $('.nce-karte_legendary').find('.markerID_' + $karteObj.data('mapobjects') + '-' + item.id).append('<a href="' + _ttgMaps.f.nceMap.adjustBaseUrl(item.tourdata.web) + '" target="_blank"><span class="' + _ttgMaps.mapOptions.markerTypes.extLink + '" aria-hidden="true"></span><span class="sr-only">' + item.titel + ' (' + $karteObj.data('fenster') + ')</span></a>');
                            }

                            $('.markerID_' + $karteObj.data('mapobjects') + '-' + item.id).data('itemdata', item);

                            // Auslastung berechnen und nur ausgeben, wenn auch die Legende ausgebeben werden soll
                            if ($('.nce-karte_legendary').hasClass('show')) {
                                _ttgMaps.f.nceMap.getAuslastung(item, '.markerID_' + $karteObj.data('mapobjects') + '-' + item.id);
                            }

                            if (item.tourdata && item.tourdata.type === 'Tour' && item.tour.initShow === '1') {
                                // Tourverlauf anzeigen
                                // Timeout notwendig, da Experience Map Style etwas Zeit braucht um geladen zu werden
                                setTimeout(function() {
                                    _ttgMaps.f.nceMap.customShowTour(item, $karteObj);
                                }, 500);
                            }

                        }
                    );

                }

                // via MapboxGL
                // const pin = new mapboxgl.Marker();
                // pin.setLngLat([item.coords.split(',')[1], item.coords.split(',')[0]]);
                // pin.addTo(ttgMaps[$karteObj.index].map);

                // via Hubermedia Framework
                pins[item.id] = ttgMaps[$karteObj.index].addMarker({
                    lat: item.coords.split(',')[0],
                    lng: item.coords.split(',')[1],
                    color: item.pin.color
                });
                let latlng = [item.coords.split(',')[0], item.coords.split(',')[1]];
                allCoords.push(latlng);

                if ($(pins[item.id]._element).find('span').length === 0) {
                    let markerID = 'markerID_' + $karteObj.data('mapobjects') + '-' + item.id;
                    $(pins[item.id]._element).addClass('ttgMaps_customPin ' + markerID).data({
                        'markerID': markerID,
                        'itemdata': item
                    });
                }

                $(pins[item.id]._element).append(_ttgMaps.f.nceMap.icon(item));
            }

        });

        if (!thisMapOptions.center.custom) {

            // Falls keine Center Koordinaten gesetzt wurden, setze den Kartenausschnitt/Zoom basierend auf den Objekten
            let north = 0, south = 0, east = 0, west = 0;
            $.each(allCoords, function(index, latlng) {
                if (index === 0) {
                    north = latlng[0];
                    south = latlng[0];
                    east = latlng[1];
                    west = latlng[1];
                }
                if (latlng[0] > north) {
                    north = latlng[0];
                }
                if (latlng[0] < south) {
                    south = latlng[0];
                }
                if (latlng[1] > east) {
                    east = latlng[1];
                }
                if (latlng[1] < west) {
                    west = latlng[1];
                }
            });
            ttgMaps[$karteObj.index].fitBounds([{ lat: south, lng: west }, { lat: north, lng: east }]);

        }

        return mapObj;

    },

    icon: function(item) {

        let $icon;

        if (item.pin.bezeichner) {

            $icon = $('<span />').addClass('ttgMaps_pinText').html(item.pin.bezeichner);

        } else if (item.pin.icon) {

            $icon = $('<span />').addClass('ttgMaps_pinSymbol').html('<span class="fa-fw ' + item.pin.icon + '" aria-hidden="true"></span>');

        } else {

            $icon = $('<span />').addClass('ttgMaps_pinSymbol').html('<span class="fa-fw ' + _ttgMaps.mapOptions.markerTypes[_ttgMaps.f.nceMap.getTDtypeString(item.tourdatatyp)] + '" aria-hidden="true"></span>');

        }

        return $icon;

    },

    legendary: function($karteObj, mapObj) {

        let row = 0,
            index = 0,
            $legendary = $karteObj.closest('.mapWrap').find('.nce-karte_legendary');

        $legendary.empty(); // Clear Loading Pin
        const makeArow = [0, 3, 6, 9, 12, 15, 18, 21, 24, 27, 30];
        $.each(mapObj, function(i, item) {

            if (item.coords) {

                if (makeArow.includes(index)) {
                    row++;
                    $legendary.append($('<div class="row row-' + row + '"></div>'));
                }

                let $col = $('<div />').addClass('col-xs-12 col-sm-12 col-md-4 col-lg-4'),
                    markerID = 'markerID_' + $karteObj.data('mapobjects') + '-' + item.id,
                    $item = $('<div />').addClass('legendaryItem ' + markerID).data('markerID', markerID),
                    $pin = $('<div />').addClass('legendaryPin').html('<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="42px" height="52px" viewBox="0 0 42 52"> <path d="M 21,1 C 9.954,1 1,10.10275 1,21.34375 1,26.407492 2.8058029,31.06341 5.8125,34.625 10.83933,39.999621 15.950478,45.546516 21,51 25.978317,45.576426 31.287399,39.938224 36.1875,34.625 39.194197,31.06341 41,26.407492 41,21.34375 41,10.10275 32.046,1 21,1 z" fill="' + item.pin.color + '" transform=""></path></svg>'),
                    $icon = _ttgMaps.f.nceMap.icon(item),
                    $content = $('<div />').addClass('legendaryContent'),
                    $titel = '<div class="title">' + item.titel + '</div>',
                    $teaser = '<div class="teaser">' + item.teaser + '</div>',
                    $auslastung = '<div class="auslastung-wrapper mt-4"></div>',
                    $link = $('<a />').attr({
                        href: item.link,
                        target: '_blank'
                    }).html('<span class="' + _ttgMaps.mapOptions.markerTypes.extLink + '" aria-hidden="true"></span><span class="sr-only">' + item.titel + ' (' + $karteObj.data('fenster') + ')</span>');
                $pin.append($icon);
                $content.append($titel, $teaser, $auslastung);
                $item.append($pin, $content);

                if (item.link) {
                    $item.append($link);
                }

                $col.append($item);

                $legendary.find('.row-' + row).append($col);

                // MOUSEENTER / MOUSELEAVE in LEGENDE
                $item
                    .on('mouseenter', function() {

                        _ttgMaps.f.nceMap.highlight({
                            mode: 'add',
                            $pinInMap: $(this).closest('.mapWrap').find('.nce-karte .mapboxgl-canvas-container .' + $(this).data('markerID')),
                            $itemInLegend: $(this)
                        }, $karteObj);

                    })
                    .on('mouseleave', function() {

                        _ttgMaps.f.nceMap.highlight({
                            mode: 'remove',
                            $pinInMap: $(this).closest('.mapWrap').find('.nce-karte .mapboxgl-canvas-container .' + $(this).data('markerID')),
                            $itemInLegend: $(this)
                        }, $karteObj);

                    })
                    .on('click', function() {

                        let $pinInMap = $(this),
                            $itemInLegend = $(this).closest('.mapWrap').find('.nce-karte .mapboxgl-canvas-container .' + $(this).data('markerID'));

                        if ($itemInLegend.hasClass('active')) {

                            $pinInMap.removeClass('active');
                            $itemInLegend.removeClass('active');

                            // Tourverlauf entfernen
                            if ($pinInMap.data('itemdata').tourdata && $pinInMap.data('itemdata').tourdata.type === 'Tour') {
                                ttgMaps[$karteObj.index].map.removeLayer('tour_' + $pinInMap.data('itemdata').tourdata.id);
                                ttgMaps[$karteObj.index].map.removeSource('tour_' + $pinInMap.data('itemdata').tourdata.id);
                            }

                        } else {

                            $pinInMap
                                .css('z-index', _ttgMaps.f.nceMap.zIndexMagic($karteObj))
                                .addClass('active')
                                .find('.pulse').css('background', $pinInMap.find('svg path').attr('fill'));
                            $itemInLegend.addClass('active')
                                .find('.pulse').css('background', $pinInMap.find('svg path').attr('fill'));

                            // Tourverlauf anzeigen
                            if ($pinInMap.data('itemdata').tourdata && $pinInMap.data('itemdata').tourdata.type === 'Tour') {
                                _ttgMaps.f.nceMap.customShowTour($pinInMap.data('itemdata'), $karteObj);
                            }

                        }

                    });

                index++;

            }

        });

    },

    getAuslastung: function(item, objClass) {

        let auslastungVal = '';
        let auslastungTxt = '';
        let peopleCounterMaxCapacity = 0;
        let peopleCounterValue = 0;
        let percentage = 0;
        let percentageText = '';

        if (item.pin.auslastung > 0) {
            //console.log(item);

            if (item.tourdata && item.tourdata.attributes) {

                // Get PeopleCounterMaxCapacity
                $.each(item.tourdata.numbers, function(index, number) {
                    if (number.type === 'PeopleCounterMaxCapacity') {
                        peopleCounterMaxCapacity = number.value;
                    }
                });

                // Get PeopleCounterValue and calculate percentage
                $.each(item.tourdata.attributes, function(index, attribute) {
                    if (attribute.key === 'PeopleCounterValue') {
                        peopleCounterValue = attribute.value;
                    }
                });

                if (peopleCounterMaxCapacity > 0 && peopleCounterValue > 0) {
                    percentage = Math.round(peopleCounterValue * 100 / peopleCounterMaxCapacity);
                    if (percentage > 0) {
                        percentageText = ' (' + percentage + '%)';
                    }
                }

                // Handle PeopleCounterState and update DOM
                $.each(item.tourdata.attributes, function(index, attribute) {
                    if (attribute.key === 'PeopleCounterState') {
                        switch (attribute.value) {
                            case 'low':
                                auslastungVal = 'low';
                                auslastungTxt = $('#map-terms').data('auslastung-low');
                                break;
                            case 'medium':
                                auslastungVal = 'medium';
                                auslastungTxt = $('#map-terms').data('auslastung-medium');
                                break;
                            case 'high':
                                auslastungVal = 'high';
                                auslastungTxt = $('#map-terms').data('auslastung-high');
                                break;
                        }

                        // Append to .auslastung-wrapper
                        $(objClass).find('.auslastung-wrapper').append(`
                        <span class="wa-signal-icon wa-signal-${ auslastungVal }">
                            <span class="bar-1"></span>
                            <span class="bar-2"></span>
                            <span class="bar-3"></span>
                            <span class="bar-4"></span>
                            <span class="bar-5"></span>
                            <span class="bar-6"></span>
                        </span>
                        <span class="text">${ auslastungTxt }${ percentageText }</span>`);
                    }
                });

            } else {
                console.warn("item.tourdata or attributes missing for item:", item);
            }
        }
    },

    adjustBaseUrl: function(url) {

        // Parse the URL
        let parsedUrl = new URL(url);

        // Get the base path after the TLD (top-level domain)
        let path = parsedUrl.pathname;

        // Get the current browser's origin (protocol + domain)
        let currentOrigin = window.location.origin;

        // Combine the current origin with the path
        return `${ currentOrigin }${ path }`;
    },

    highlight: function(highlight, $karteObj) {

        let $pulse = $('<div class="pulse"></div>').html('<div class="animate" style="box-shadow: 0 0 1px 2px ' + highlight.$pinInMap.find('svg path').attr('fill') + '"></div>'),
            hex2rgba = function(hex) {
                var c;
                if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
                    c = hex.substring(1).split('');
                    if (c.length == 3) {
                        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
                    }
                    c = '0x' + c.join('');
                    return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ', 0.1)';
                }
                throw new Error('Bad Hex');
            };

        // console.log(highlight);

        switch (highlight.mode) {
            case 'add':

                if (!highlight.$itemInLegend.hasClass('active')) {

                    // Highlight & Pulse in Legende
                    if (!highlight.$itemInLegend.hasClass('highlight')) {
                        highlight.$itemInLegend.addClass('highlight').css({
                            'border': '2px solid ' + highlight.$itemInLegend.find('svg path').attr('fill'),
                            'background': hex2rgba(highlight.$itemInLegend.find('svg path').attr('fill'))
                        }).find('.legendaryPin').append($pulse);
                    }

                    let link = '', linkClass = ' withLink';
                    if (highlight.$pinInMap.data('itemdata') && highlight.$pinInMap.data('itemdata').link) {
                        link = ' <a href="' + highlight.$pinInMap.data('itemdata').link + '" target="_blank"><span class="' + _ttgMaps.mapOptions.markerTypes.extLink + '"></span ></a>';
                    } else if (highlight.$pinInMap.data('itemdata') && highlight.$pinInMap.data('itemdata').tourdata && highlight.$pinInMap.data('itemdata').tourdata.web) {
                        link = ' <a href="' + _ttgMaps.f.nceMap.adjustBaseUrl(highlight.$pinInMap.data('itemdata').tourdata.web) + '" target="_blank"><span class="' + _ttgMaps.mapOptions.markerTypes.extLink + '"></span ></a>';
                    } else {
                        linkClass = '';
                    }

                    console.log("Link: " + link, highlight.$pinInMap.data('itemdata'));

                    // Pulse & Title in Map
                    let $title = $('<div class="title' + linkClass + '">' + highlight.$pinInMap.data('itemdata').titel + link + '</div>');
                    highlight.$pinInMap
                        .append(
                            $pulse.clone(),
                            $title.on('click', function(e) { e.stopPropagation(); })
                        );

                    highlight.$pinInMap.css('z-index', _ttgMaps.f.nceMap.zIndexMagic($karteObj));

                }

                break;

            case 'remove':

                if (!highlight.$itemInLegend.hasClass('active')) {

                    // Entferne Highlight & Pulse in Legende
                    highlight.$itemInLegend.removeClass('highlight').css({
                        'border': '',
                        'background': ''
                    }).find('.legendaryPin .pulse').remove();

                    // Entferne Pulse & Title in Map
                    highlight.$pinInMap.find('.pulse, .title').remove();
                    highlight.$pinInMap.css('z-index', 'auto');

                }

                break;
        }

    },

    showTourLines: function(items, $karteObj) {

        const addSourceAndLayer = function(tour) {

            ttgMaps[$karteObj.index].map.addSource("tour_" + tour.id, {
                "type": "geojson",
                "data": {
                    "type": "Feature",
                    "geometry": {
                        "type": "LineString",
                        "coordinates": _ttgMaps.f.tourGeoString2Arr(tour.geo.geometry.value)
                    }
                }
            });

            ttgMaps[$karteObj.index].map.addLayer({
                'id': 'tour_' + tour.id,
                'type': 'line',
                'source': 'tour_' + tour.id,
                'layout': {
                    'visibility': 'visible',
                    'line-join': 'round',
                    'line-cap': 'round'
                },
                'paint': {
                    'line-color': _ttgMaps.pinColors.selected,
                    'line-width': 3
                }
            }, firstSymbolId); // Lines hinter Pins anzeigen

        };

        // Lines hinter Pins anzeigen
        const layers = ttgMaps[$karteObj.index].map.getStyle().layers;
        let firstSymbolId;
        for (const layer of layers) {
            if (layer.type === 'symbol') {
                firstSymbolId = layer.id;
                break;
            }
        }

        // Check ob bereits tourLines im Array sind > wenn nicht laden
        if (!ttgMaps[$karteObj.index].tourLines.length) {

            $.each(items, function(index, item) {

                if (item.type === "Tour") {

                    _ttgMaps.f.getMapItem(item).then(
                        response => {

                            const tour = response.items[0];
                            addSourceAndLayer(tour);
                            ttgMaps[$karteObj.index].tourLines[index] = tour;

                        }
                    );


                }

            });

        } else {

            // Falles tourLines vorhanden sind, nimm gleich Diese und füge sie der Karte hinzu
            $.each(ttgMaps[$karteObj.index].tourLines, function(index, tour) {
                addSourceAndLayer(tour);
            });

        }

    },

    customShowTour: function(itemdata, $karteObj) {
        // console.log('customShowTour()');

        try {
            // Lines hinter Pins anzeigen
            const layers = ttgMaps[$karteObj.index].map.getStyle().layers;
            let firstSymbolId;
            for (const layer of layers) {
                // if (layer.type === 'symbol') {
                if (layer.id === 'water_name_line') {
                    firstSymbolId = layer.id;
                    break;
                }
            }

            ttgMaps[$karteObj.index].map.addSource("tour_" + itemdata.tourdata.id, {
                "type": "geojson",
                "data": {
                    "type": "Feature",
                    "geometry": {
                        "type": "LineString",
                        "coordinates": _ttgMaps.f.tourGeoString2Arr(itemdata.tourdata.geo.geometry.value)
                    }
                }
            });

            ttgMaps[$karteObj.index].map.addLayer({
                'id': 'tour_' + itemdata.tourdata.id,
                'type': 'line',
                'source': 'tour_' + itemdata.tourdata.id,
                'layout': {
                    'visibility': 'visible',
                    'line-join': 'round',
                    'line-cap': 'round'
                },
                'paint': {
                    'line-color': (itemdata.tour.color) ? itemdata.tour.color : _ttgMaps.pinColors.selected,
                    'line-width': 3
                }
            }, firstSymbolId);

            // Tour in Array speichern
            if (ttgMaps[$karteObj.index].tourLines.indexOf(itemdata) === -1) {
                ttgMaps[$karteObj.index].tourLines.push(itemdata);
            }
        } catch (e) {
            console.log('_ttgMaps.f.nceMap.customShowTour()', 'Tour bereits vorhanden');
            console.log(e);
        }

    },

    getTDtypeString: function(typeNum) {
        itemTypes = ['custom', 'gastro', 'ort', 'package', 'poi', 'region', 'tour', 'hotel', 'event', 'hotel'];
        //letztes Item ist "Location"
        return itemTypes[typeNum];
    }

};

window.addEventListener('fullscreenchange', (event) => {

    $.each(ttgMaps, function() {
        const map = this,
            $map = $(map.map._container);

        if ($map.data('mapobjects')) {

            if (map.isFullscreen() && !$map.find('.fullScreenContent').length) {

                let $fullScreenContent = $('<div />').addClass('fullScreenContent');
                $fullScreenContent.html($map.closest('.mapWrap').find('.nce-karte_legendary'));

                $map.append($fullScreenContent);

            } else {

                $map.find('.fullScreenContent .nce-karte_legendary').insertAfter($map);
                $map.find('.fullScreenContent').remove();

            }

        }

    });

});
